/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core'

const qs = require('qs')

/**
 * GetAtpToken Input Action
 */
interface IToken {
  token_type: string
  expires_in: string
  ext_expires_in: string
  expires_on: string
  not_before: string
  resource: string
  access_token: string
}

export class GetAtpTokenInput implements Msdyn365.IActionInput {
  // TODO: Construct the input needed to run the action
  constructor() {}

  // TODO: Determine if the results of this get action should cache the results and if so provide
  // a cache object type and an appropriate cache key
  public getCacheKey = () => `getAtpToken`
  public getCacheObjectType = () => 'getAtpToken'
  public dataCacheType = (): Msdyn365.CacheType => 'application'
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (
  args: Msdyn365.ICreateActionContext
): Msdyn365.IActionInput => {
  return new GetAtpTokenInput()
}

async function getToken(ctx: any) {
  let baseUrl = ctx.requestContext.apiSettings.baseUrl
  const clientId:
    | Msdyn365.ISecretValue
    | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue(
    'atp-client-id',
    baseUrl
  )
  const clientSecret:
    | Msdyn365.ISecretValue
    | undefined = await Msdyn365.msdyn365Commerce.secretManager?.getSecretValue(
    'atp-client-secret',
    baseUrl
  )

  if (process.env.CURRENT_ENVIRONMENT === 'node') {
    const data = await qs.stringify({
      grant_type: 'client_credentials',
      client_id: clientId?.value || ctx.requestContext.app.config.testClientId,
      client_secret:
        clientSecret?.value || ctx.requestContext.app.config.testClientSecret,
      scope: ctx.requestContext.app.config.clientScope
    })
    const token = await Msdyn365.sendRequest<IToken>(
      ctx.requestContext.app.config.rcvAtpTokenApiUrl,
      'post',
      data,
      {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    )
    return { token: token.data.access_token }
  }

  return { token: '' }
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getAtpTokenAction(
  input: GetAtpTokenInput,
  ctx: Msdyn365.IActionContext
): Promise<any> {
  const response = await getToken(ctx)
  return response
}

export default Msdyn365.createObservableDataAction({
  action: <Msdyn365.IAction<string>>getAtpTokenAction,
  // TODO: Give your data action a unique id
  id: 'GetAtpToken',
  input: createInput
  // TODO: Uncomment the below line if this is a meant to be a batched data action
  // isBatched: true
})
